<template>
  <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog')" @keydown.esc="$emit('updateDialog')" width="500">
    <v-card>
      <v-card-title class="title-modal">
        <span class="headline">{{ modal_title }}</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-combobox 
            v-model="item.component_product_presentation" 
            name="presentation" 
            item-title="label" 
            item-value="id" 
            :items="presentations"
            label="Presentación*" 
            autocomplete="off" 
            :rules="[rules.requiredComboBox]"
            clearable
          ></v-combobox>

          <v-text-field 
            v-model="item.amount" 
            name="amount" 
            label="Cantidad*" 
            type="number" 
            :rules="[rules.required, rules.positiveNumber]"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="$emit('updateDialog')">Cancelar</v-btn>
        <v-btn color="green" text @click="createItem()" :loading="loading">{{ itemEdit != null ? "Editar" : "Agregar" }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { productoService } from "@/libs/ws/productoService";
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
  created() {},
  mixins: [ValidMixin],
  components: {},
  props: {
    dialog: Boolean,
    updateDialog: Function,
    itemEdit: Object,
    product: Object,
  },
  data: () => ({
    item: {
      component_product_presentation: null,
      amount: 1,
    },
    defaultItem: null,
    loading: false,
    modal_title: "Composición",
    presentations: [],
  }),
  watch: {
    dialog() {
      if (this.dialog) {
        if (this.itemEdit == null) {
          this.item = JSON.parse(JSON.stringify(this.defaultItem));
        } else {
          this.item = JSON.parse(JSON.stringify(this.itemEdit));
        }
        this.loadCompositions();
      }
    },
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    async loadCompositions() {
      if (this.product && this.product.client && this.product.client.id > 0) {
        try {
          const response = await productoService.getCompositions({
            client: this.product.client.id,
          });
          if (response && response.status) {
            this.presentations = response.result.list;
          }
        } catch (error) {
          console.error("Error loading compositions:", error);
          this.toast.error("Error al cargar las presentaciones");
        }
      }
    },
    async createItem() {
      if (this.loading) return;
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.loading = true;

        const compositionData = {
          ...this.item,
          component_product_presentation: this.item.component_product_presentation,
          amount: this.item.amount
        };

        this.$emit("addComposition", compositionData);
        this.loading = false;
       
      }
    },
  },
};
</script>
